module.exports = __webpack_public_path__ + "media/images/products-bg-2eabc171cdcdcbbc64bfee2e354af7d2.svg";